<template>
    <GmapMap :center="{lat:location.latitude, lng:location.longitude}"
            ref="mapRef"
               :zoom="14"
               @click="marker"
               map-type-id="terrain"
               style="width: 550px; height: 300px" >
        <GmapMarker
                :position="{lat:location.latitude, lng:location.longitude}"
                :clickable="true"
                :draggable="true"
                :content="'Hello world'"
                @dragend="marker"
        ></GmapMarker>
        <gmap-info-window
                :options="{ pixelOffset: {
                        width: 0,
                        height: -40
                    },content: content}"
                :position="{lat:location.latitude, lng:location.longitude}"
                @closeclick="infoOpened=false">

        </gmap-info-window>
    </GmapMap>
</template>

<script>
    export default {
        name: "map-location",
        props: {
            defLocation: {
                required: true,
            },
            defContent: {
                required: true,
            }
        },
        watch: {
            defLocation: {
                handler: _.debounce(
                    function () {
                       this.location=this.defLocation;
                        console.log('watch map location address');
                    }, 100
                ),
                deep: true
            },
            defContent: {
                handler: _.debounce(
                    function () {
                        this.content=this.defContent;
                    }, 100
                ),
                deep: true
            },
        },
        methods:{
          marker(event){
              var geocoder = new google.maps.Geocoder;
              let newContent='';
              let vm=this;
              //this.location.latitude=event.latLng.lat();
              //this.location.longitude=event.latLng.lng();
              this.$refs.mapRef.$mapPromise.then((map) => {
                  map.panTo({lat: event.latLng.lat(), lng: event.latLng.lng()});
              });
              geocoder.geocode({'location': {lat: event.latLng.lat(), lng:event.latLng.lng() }}, function(results, status) {
                      if (status === 'OK') {
                          if (results[0]) {
                              let street=undefined;
                              if (results[0].address_components[0].types.indexOf('street_number')!==-1){
                                  street=true;
                              }
                              let end_address = '';
                              results[0].address_components.forEach((item) => {
                                  end_address = end_address + item.long_name + ', ';
                              });
                              vm.content = end_address;
                              vm.$emit('change-data',{latlng:{lat: event.latLng.lat(), lng:event.latLng.lng() },content:vm.content,street_number:street});
                          } else {
                              window.alert('No results found');
                          }
                      } else {
                          console.log(status);
                          window.alert('Geocoder failed due to: ' + status);
                      }
                  });
          }
        },
        data: function () {
            return {
                location:{
                    lat:'',
                    lng:'',
                },
                content:'',
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -40
                    },
                }
            }
        },
        mounted() { 
            this.$refs.mapRef.$mapPromise.then((map) => {
                map.panTo({lat: 1.38, lng: 103.80});
            })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/js/components/MapLocation.vue